import type { PetCard } from "@highmarch/app";
import { petPortraitHtml } from "./petArt";
import { jobLine, levelShare, levelWords, noPetWords } from "./petWords";

/**
 * The pet chip on the pre-battle surfaces (docs/PETS.md): the battle card and the campaign map's level panel. The
 * portrait, the name, "Lv 6" with a small bar to the level cap, and its abilities in a line; a tap opens the picker of
 * every pet had (petPick.ts; features/pets.ts redraws the chip in place). `on`: it comes into the next battle.
 */
export function petChipHtml(card: PetCard, on: boolean): string {
  const pet = card.pet, job = jobLine(card);
  const label = `${pet.name}, ${levelWords(card)}. ${on ? `${job}.` : "Staying home."} Tap to choose who comes along.`;
  return `<button type="button" class="petchip${on ? " on" : ""}" data-pet="${pet.id}" aria-pressed="${on}" aria-label="${label}">`
    + `${petPortraitHtml(pet.id, 40)}`
    + `<span class="pc-t"><span class="pc-h"><b class="disp">${pet.name}</b><small class="pc-b">${levelWords(card)}</small></span>`
    + `<i class="pc-bar" aria-hidden="true"><i style="width:${Math.round(levelShare(card) * 100)}%"></i></i>`
    + `<small class="pc-job">${on ? job : "All stay home · tap to choose"}</small></span>`
    + `<span class="pc-sw" aria-hidden="true"><i></i></span></button>`;
}

/**
 * Before any pet is caught: the same chip, empty — a paw-print in the portrait's place, "Wild pets" and where they roam
 * (`fromLevel`). Not a button: there is nothing to bring along yet.
 */
export function emptyPetChipHtml(fromLevel: number): string {
  const w = noPetWords(fromLevel);
  return `<div class="petchip nopet" role="note" aria-label="${w.title}. ${w.sub}"><span class="petport none" style="width:40px;height:40px" aria-hidden="true"><i class="pp-paw"></i></span>`
    + `<span class="pc-t"><span class="pc-h"><b class="disp">${w.title}</b></span><small class="pc-job">${w.sub}</small></span></div>`;
}

/** The row on one surface (the pre-battle rows' wrapper): the chip, then the treat well when there is one. */
export function petRowHtml(surface: "card" | "map", chip: string, treat = ""): string {
  return `<div class="prebattle pb-${surface} petpb${treat ? " withtreat" : ""}">${chip}${treat}</div>`;
}
